import TicketsbyDingPayLogo from "../assets/imgs/tbdingpay-logo.svg";

export function LoadingPage({ text }: { text?: string }) {
  return (
    <div className="loading-page">
      <img src={TicketsbyDingPayLogo} alt="Loading..." className="logo" />
      {text ? <p>{text}</p> : null}
    </div>
  );
}
